<template>
  <div class="zy-health sleep-page">
    <!-- 顶部导航栏 - 参考 skinTemperature 页面 -->
    <header class="sleep-header" :style="{paddingTop: statusBarHeight + 'px'}">
      <div class="header-background">
        <img src="@/assets/personalInformation/headbackground.png" alt="背景" class="header-bg-img" />
      </div>
      <div class="header-nav">
        <button 
          class="nav-back-btn" 
          @click="goBack"
          :style="{top: (statusBarHeight + 12) + 'px'}"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <div class="nav-title">睡眠</div>
        <div class="nav-placeholder"></div>
      </div>
    </header>

    <!-- 内容区域 -->
    <div class="sleep-content" :style="{paddingTop: (statusBarHeight + 80) + 'px'}">
      <!-- 睡眠时长数据卡片 - 参考 bloodOxygen 页面结构 -->
      <div class="sleep-header-card">
        <div class="sleep-header-top">
          <div class="sleep-header-left">
            <div class="sleep-title-section">
              <i class="sleep-icon"></i>
              <span class="sleep-title-text">睡眠时长</span>
            </div>
            <div class="sleep-value-section">
              <span class="sleep-value">{{ totalTime || '--' }}</span>
            </div>
            <div class="sleep-time-range" v-if="sleepStartTime && sleepEndTime">
              {{ sleepStartTime }} - {{ sleepEndTime }}
            </div>
          </div>
          <div class="sleep-header-right">
            <div class="sleep-date" @click="timeClick()">
              {{ newtime }} {{ week }}
              <i class="el-icon-caret-bottom"></i>
            </div>
          </div>
        </div>
        <!-- 圆形图表区域 -->
        <div class="sleep-chart-container">
          <div class="sleep-chart-wrapper">
            <div ref="sleepChart" class="sleep-chart"></div>
            <!-- 中心显示睡眠得分 -->
            <div class="sleep-chart-score">
              <div class="sleep-chart-score-value">{{score || '--'}}</div>
              <div class="sleep-chart-score-label">睡眠得分</div>
            </div>
          </div>
        </div>
        <!-- 睡眠阶段图例 -->
        <div class="sleep-stage-legend">
          <div class="sleep-stage-item">
            <div class="stage-label-row">
              <div class="stage-icon deep-sleep-icon"></div>
              <span class="stage-label">深睡时长</span>
            </div>
            <span class="stage-value">
              <span class="stage-value-number">{{deepSleep}}</span>
              <span class="stage-value-unit">分钟</span>
            </span>
          </div>
          <div class="sleep-stage-item">
            <div class="stage-label-row">
              <div class="stage-icon light-sleep-icon"></div>
              <span class="stage-label">浅睡时长</span>
            </div>
            <span class="stage-value">
              <span class="stage-value-number">{{lightSleep}}</span>
              <span class="stage-value-unit">分钟</span>
            </span>
          </div>
          <div class="sleep-stage-item">
            <div class="stage-label-row">
              <div class="stage-icon rem-sleep-icon"></div>
              <span class="stage-label">快速眼动</span>
            </div>
            <span class="stage-value">
              <span class="stage-value-number">{{rem}}</span>
              <span class="stage-value-unit">分钟</span>
            </span>
          </div>
        </div>
      </div>
       
      <!-- 睡眠心率卡片 -->
      <div class="sleep-heart-rate-card">
        <div class="shr-header">
          <div class="shr-title-section">
            <div class="shr-icon"></div>
            <span class="shr-title-text">睡眠心率</span>
          </div>
        </div>
        
        <div class="shr-chart-wrapper">
          <echarts1 :detailTimes="detailTimes" :details="details"></echarts1>
        </div>
        
        <div class="shr-stats">
          <div class="shr-stat-item">
            <span class="shr-stat-label">睡眠平均心率</span>
            <span class="shr-stat-value">{{heartAvg}}次/分钟</span>
          </div>
          <div class="shr-stat-item">
            <span class="shr-stat-label">
              睡眠低血氧异常
              <div
                class="shr-question"
                @click="
                  bulletFrameIf = true;
                  title = '什么是睡眠低血氧异常';
                  name1 =
                    '睡眠低血氧异常就是在睡眠期间的血氧水平掉到了正常值以下(通常是低于90%)，它与睡眠过程中的低通气呼吸障碍症状有关，是诊断和评估睡眠呼吸问题严重性的重要依据。';
                "
              >
                ?
              </div>
            </span>
            <span class="shr-stat-value">{{breathWarn}}次</span>
          </div>
        </div>
      </div>
    <!-- 睡眠时长 -->
    <div class="sleep-stats-card">
      <div class="ssc-title">
        <span>睡眠时长</span>
      </div>
      <div class="ssc-content">
        <div class="ssc-value-row">
          <div class="ssc-main-value">{{totalTime}}</div>
          <div class="ssc-status-tag">
            <div class="ssc-state ssc-state-normal" v-if="sleepState == '正常'">{{sleepState}}</div>
            <div class="ssc-state ssc-state-low" v-else-if="sleepState == '偏低'">{{sleepState}}</div>
            <div class="ssc-state ssc-state-high" v-else-if="sleepState == '偏高'">{{sleepState}}</div>
          </div>
        </div>
        <div class="ssc-reference">
          <span>参考值：{{sleepRef}}</span>
          <span>多于{{sleepCompRate}}%的用户</span>
        </div>
      </div>
    </div>
    <!-- 深睡时长 -->
    <div class="sleep-stats-card">
      <div class="ssc-title">
        <span>深睡时长</span>
      </div>
      <div class="ssc-content">
        <div class="ssc-value-row">
          <div class="ssc-main-value">{{deepSleep}}分钟</div>
          <div class="ssc-status-tag">
            <div class="ssc-state ssc-state-normal" v-if="deepState == '正常'">{{deepState}}</div>
            <div class="ssc-state ssc-state-low" v-else-if="deepState == '偏低'">{{deepState}}</div>
            <div class="ssc-state ssc-state-high" v-else-if="deepState == '偏高'">{{deepState}}</div>
          </div>
        </div>
        <div class="ssc-progress-wrapper">
          <div class="ssc-progress-bar">
            <div class="ssc-progress-fill" :style="{ width: deepRate + '%' }"></div>
            <div class="ssc-progress-dot" :style="{ left: deepRate - 1 + '%' }">
              <div class="ssc-progress-label">占比{{ deepRate }}%</div>
            </div>
          </div>
        </div>
        <div class="ssc-reference">
          <span>参考值：{{deepRef}}</span>
          <span>多于{{deepCompRate}}%的用户</span>
        </div>
      </div>
    </div>
    <!-- 快速眼动时长 -->
    <div class="sleep-stats-card">
      <div class="ssc-title">
        <span>
          快速眼动时长
          <div
            class="ssc-question"
            @click="
              bulletFrameIf = true;
              title = '什么是快速眼动（REM）';
              name1 =
                '快速眼动睡眠期（REM）是睡眠分期中一个重要的阶段，通常也是梦境产生的阶段。快速眼动睡眠的唤醒阀高于浅睡眠，低于深睡眠。在此阶段，肌肉一般处于松弛状态，眼球会不自觉的做快速无规则的转动。快速眼动睡眠时间对于精神健康非常重要，有助于提升创造力，舒缓压力。';
            "
          >
            ?
          </div>
        </span>
      </div>
      <div class="ssc-content">
        <div class="ssc-value-row">
          <div class="ssc-main-value">{{rem}}分钟</div>
          <div class="ssc-status-tag">
            <div class="ssc-state ssc-state-normal" v-if="remState == '正常'">{{remState}}</div>
            <div class="ssc-state ssc-state-low" v-else-if="remState == '偏低'">{{remState}}</div>
            <div class="ssc-state ssc-state-high" v-else-if="remState == '偏高'">{{remState}}</div>
          </div>
        </div>
        <div class="ssc-progress-wrapper">
          <div class="ssc-progress-bar">
            <div class="ssc-progress-fill" :style="{ width: remCompRate + '%' }"></div>
            <div class="ssc-progress-dot" :style="{ left: remCompRate - 1 + '%' }">
              <div class="ssc-progress-label">占比{{ remCompRate }}%</div>
            </div>
          </div>
        </div>
        <div class="ssc-reference">
          <span>参考值：{{remRef}}</span>
        </div>
      </div>
    </div>
    <!-- 清醒次数 -->
    <div class="sleep-stats-card">
      <div class="ssc-title">
        <span>夜间清醒次数</span>
      </div>
      <div class="ssc-content">
        <div class="ssc-value-row">
          <div class="ssc-main-value">{{wakeCount}}次</div>
          <div class="ssc-status-tag">
            <div class="ssc-state ssc-state-normal" v-if="wakeState == '正常'">{{wakeState}}</div>
            <div class="ssc-state ssc-state-low" v-else-if="wakeState == '偏低'">{{wakeState}}</div>
            <div class="ssc-state ssc-state-high" v-else-if="wakeState == '偏高'">{{wakeState}}</div>
          </div>
        </div>
        <div class="ssc-reference">
          <span>参考值：{{wakeRef}}</span>
        </div>
      </div>
    </div>
      <picke
        @child-method="parentMethod"
        :value="value"
        :leftTime="leftTime"
      ></picke>
      <bulletFrame
        @close-method="closeMethod"
        :bulletFrameIf="bulletFrameIf"
        :title="title"
        :name="name1"
      ></bulletFrame>

      <!-- 免责声明 + 开始分析（参考血氧页；仅聚合页 Tab 内嵌时展示按钮） -->
      <div class="health-disclaimer">
        <p>注:非医疗设备,结果仅供参考,如有不适,请及时就医</p>
        <StartAnalysisCta :embedded="embedded" @click="$emit('start-analysis')" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global';
import * as echarts from "echarts";
import { sleep } from '@/api/activity'
import { SleepWave, EventBus } from ".././canvas/js/sleepWave";
import StartAnalysisCta from '@/components/StartAnalysisCta'
export default {
  name: 'sleep',
  props: {
    /**
     * 是否为聚合页 Tab 内嵌场景（内嵌时才展示开始分析按钮）
     * @type {boolean}
     */
    embedded: { type: Boolean, default: false }
  },
  data() {
    return {
      wake:0,
      leftTime: "",
      nameType: "",
      title: "",
      name1: "",
      bulletFrameIf: false,
      data: [],
      details:[],
      detailTimes:[],
      progress: 50,
      echartsTime: "00:00",
      name: "0",
      time: "1",
      time1: "2",
      newtime: "",
      value: false,
      week: "",
      chartInstance: null,
      totalTime:'',
      score:0,
      lightSleep:0,
      wakeCount:0,
      rem:0,
      deepSleep:0,
      totalTime:0,
      heartAvg:0,
      breathWarn:0,
      sleepRef:0,
      sleepState:'',
      sleepCompRate:0,
      deepRate:0,
      deepState:'',
      deepRef:0,
      deepCompRate:0,
      remCompRate:0,
      remRef:0,
      wakeState:'',
      wakeRef:0,
      remState:'',
      sleepStartTime:'',
      sleepEndTime:''
    };
  },
  components: {
    picke: () => import("@/components/picke"),
    bulletFrame: () => import("@/components/bulletFrame"),
    echarts1: () => import("@/views/echarts"),
    StartAnalysisCta,
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight']),
  },
  mounted() {
    if(localStorage.getItem('oldAge') == 1) {
          document.getElementById("html").style.fontSize = "37.5px";
        }
    // this.timeRight = this.$route.query.sleepUpTime
    document.title = '睡眠' 
    // 设置 body 背景色，确保滚动时背景色不丢失
    document.body.style.backgroundColor = '#F2F3F5';
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
    window.addEventListener("resize", this.handleResize);
    // this.initChart();
   
  },
  beforeDestroy() {
    // 恢复 body 背景色
    document.body.style.backgroundColor = '';
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#F3F4F6 !important");
    window.removeEventListener("resize", this.handleResize);
    
    // 销毁图表实例
    if (this.chartInstance) {
      this.chartInstance.dispose();
      this.chartInstance = null;
    }
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.go(-1);
    },
    getData() {
      var obj = {
        type:1,
        dat:this.getTransferTime(this.transferTime(this.time))
      }
      sleep(obj).then((res)=> {
        if(res.code == 1000) {
          if(res.data != undefined) {
              if(res.data.wake < 0) {
                this.wake = 0
              }else {
                this.wake = res.data.wake || 0
              }
              if(res.data.sleepStartTime) {
                this.sleepStartTime = res.data.sleepStartTime.slice(-8).replace(/.{3}$/, ''); 
                this.sleepEndTime = res.data.sleepEndTime.slice(-8).replace(/.{3}$/, '');
              }
             
              this.score = res.data.score || 0
              this.lightSleep = res.data.lightSleep || 0
              this.wakeCount = res.data.wakeCount ||  0
              this.rem = res.data.rem || 0
              this.deepSleep =res.data.deepSleep|| 0  
              this.totalTime = res.data.totalTime || 0
              this.data = [
                { value: this.deepSleep, name: '深睡',itemStyle: {color: '#008C00'}},
                { value: this.lightSleep, name: '浅睡',itemStyle: {color: '#00C275'}},
                { value: this.rem, name: '快速眼动',itemStyle: {color: '#FF9315'}},
                { value: this.wakeCount, name: '清醒',itemStyle: {color: '#FFC215'}}
              ]
              this.breathWarn = res.data.breathWarn || 0
              this.heartAvg = res.data.heartAvg || 0
              this.details = res.data.details || []
              this.detailTimes = res.data.detailTimes || []
              this.sleepRef = res.data.sleepRef 
              this.sleepState = res.data.sleepState
              this.sleepCompRate =res.data.sleepCompRate || 0
              this.deepState = res.data.deepState
              this.deepRef = res.data.deepRef || 0
              this.deepCompRate = res.data.deepCompRate || 0
              this.remRef = res.data.remRef || 0
              this.wakeState = res.data.wakeState
              this.wakeRef = res.data.wakeRef
              this.remState = res.data.remState
              this.deepRate = res.data.deepRate || 0
              this.remCompRate = res.data.remCompRate || 0
          }else {
            this.sleepStartTime = ''
            this.sleepEndTime = ''
            this.wake = 0
            this.score = 0
              this.lightSleep =  0
              this.wakeCount =   0
              this.rem = 0
              this.deepSleep = 0  
              this.totalTime =  0
              this.data = [
                { value: this.deepSleep, name: '深睡',itemStyle: {color: '#008C00'}},
                { value: this.lightSleep, name: '浅睡',itemStyle: {color: '#00C275'}},
                { value: this.rem, name: '快速眼动',itemStyle: {color: '#FF9315'}},
                { value: this.wakeCount, name: '清醒',itemStyle: {color: '#FFC215'}}
              ]
              this.breathWarn =  0
              this.heartAvg =  0
              this.details =  []
              this.detailTimes =  []
              this.sleepRef = ''
              this.sleepState =''
              this.sleepCompRate = 0
              this.deepState = ''
              this.deepRef =  0
              this.deepCompRate =  0
              this.remRef =  0
              this.wakeState = ''
              this.wakeRef = ''
              this.remState = ''
              this.deepRate =  0
              this.remCompRate =  0
          }
          this.initChart();
         
        }
        console.log(res.data)
      })
    },
    startDrag(e) {
      EventBus.$on("title", (message) => {
        console.log(message);
        if (message == 1) {
          this.nameType = "深睡";
        } else if (message == 2) {
          this.nameType = "浅睡";
        } else if (message == 3) {
          this.nameType = "快速眼动";
        } else if (message == 4) {
          this.nameType = "清醒";
        }
      });
      EventBus.$on("value", (message) => {
        console.log(message);
        this.name = message;
      });
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },
    myCanvasClick(e) {},
    renderCardList(data) {
      this.echartsTime = data.name;
      this.name = data.value;
    },
    /**
     * 初始化echarts图表 - 参考 healthHomePage Sleep 组件
     */
    initChart() {
      if (!this.$refs.sleepChart) return;
      
      if (this.chartInstance) {
        this.chartInstance.dispose();
      }
      
      this.chartInstance = echarts.init(this.$refs.sleepChart);
      
      // 计算睡眠时间段
      const sleepStartTime = this.sleepStartTime || '';
      const sleepEndTime = this.sleepEndTime || '';
      
      // 解析时间并转换为角度
      const startAngle = this.timeToAngle(sleepStartTime);
      const endAngle = this.timeToAngle(sleepEndTime);
      
      // 计算各睡眠阶段的时长
      const totalTime = this.parseDuration(this.totalTime) || 0;
      
      // 处理深睡数据：可能是数字（分钟）或字符串
      let deepSleepTime = 0;
      if (this.deepSleep !== undefined && this.deepSleep !== null) {
        if (typeof this.deepSleep === 'number') {
          deepSleepTime = this.deepSleep;
        } else {
          deepSleepTime = this.parseDuration(this.deepSleep) || 0;
        }
      }
      
      // 处理浅睡数据
      let lightSleepTime = 0;
      if (this.lightSleep !== undefined && this.lightSleep !== null) {
        if (typeof this.lightSleep === 'number') {
          lightSleepTime = this.lightSleep;
        } else {
          lightSleepTime = this.parseDuration(this.lightSleep) || 0;
        }
      }
      
      // 处理快速眼动数据
      let remTime = 0;
      if (this.rem !== undefined && this.rem !== null) {
        if (typeof this.rem === 'number') {
          remTime = this.rem;
        } else {
          remTime = this.parseDuration(this.rem) || 0;
        }
      }
      
      // 计算各阶段的角度范围
      const sleepDuration = endAngle > startAngle ? endAngle - startAngle : (360 - startAngle + endAngle);
      
      // 如果总时长为0，尝试使用各阶段时长之和
      const calculatedTotalTime = totalTime || (deepSleepTime + lightSleepTime + remTime);
      
      // 构建饼图数据 - 使用 healthHomePage 的颜色配置
      const pieData = [];
      if (deepSleepTime > 0) {
        pieData.push({
          value: deepSleepTime,
          name: '深睡',
          itemStyle: {
            color: '#4B37FF'
          }
        });
      }
      if (lightSleepTime > 0) {
        pieData.push({
          value: lightSleepTime,
          name: '浅睡',
          itemStyle: {
            color: '#7B76FF'
          }
        });
      }
      if (remTime > 0) {
        pieData.push({
          value: remTime,
          name: '快速眼动',
          itemStyle: {
            color: '#43D867'
          }
        });
      }
      
      // 计算饼图起始角度
      // pie图的startAngle：0度在右侧，顺时针为正
      // 需要从睡眠开始时间开始，所以使用startAngle，并加上90度偏移（因为0度在右侧，顶部是-90度）
      const pieStartAngle = startAngle + 90;
      
      const series = [
        // 24小时时钟刻度背景
        {
          type: 'gauge',
          center: ['50%', '50%'],
          radius: '85%',
          startAngle: 0,
          endAngle: 360,
          min: 0,
          max: 24,
          splitNumber: 24,
          axisLine: {
            show: false
          },
          axisTick: {
            show: true,
            length: 6,
            lineStyle: {
              color: '#CCCCCC',
              width: 1
            },
            distance: -8
          },
          splitLine: {
            show: true,
            length: 10,
            lineStyle: {
              color: '#CCCCCC',
              width: 1
            },
            distance: -8
          },
          axisLabel: {
            show: false
          },
          pointer: {
            show: false
          },
          detail: {
            show: false
          }
        },
        // 睡眠阶段环形饼图
        {
          type: 'pie',
          center: ['50%', '50%'],
          radius: ['60%', '72%'], // 内半径60%，外半径72%，形成更细的环形
          startAngle: pieStartAngle,
          data: pieData,
          label: {
            show: false
          },
          labelLine: {
            show: false
          },
          itemStyle: {
            borderRadius: [12, 12], // 设置圆角，让扇形两端有圆角效果，相邻扇形看起来压在一起
            borderWidth: 0
          },
          emphasis: {
            disabled: true
          },
          animation: false
        }
      ];
      
      const option = {
        series: series
      };
      
      this.chartInstance.setOption(option);
      
      // 解决高DPI屏幕模糊问题：设置高分辨率
      this.$nextTick(() => {
        const canvas = this.$refs.sleepChart.querySelector('canvas');
        if (canvas) {
          const container = this.$refs.sleepChart;
          const rect = container.getBoundingClientRect();
          const dpr = window.devicePixelRatio || 2;
          
          // 设置canvas实际尺寸为显示尺寸的2倍
          canvas.width = rect.width * dpr;
          canvas.height = rect.height * dpr;
          
          // 保持CSS显示尺寸不变
          canvas.style.width = rect.width + 'px';
          canvas.style.height = rect.height + 'px';
          
          // 重新渲染图表以应用新的尺寸
          this.chartInstance.resize();
        }
      });
    },
    /**
     * 将时间转换为角度（0-360度，0度在顶部）
     * @param {string} timeStr - 时间字符串，格式如 "23:29" 或 "2025-11-10 23:29:00"
     * @returns {number} 角度值
     */
    timeToAngle(timeStr) {
      if (!timeStr) return 0;
      
      // 确保是字符串类型
      const timeString = String(timeStr);
      
      let hour = 0;
      let minute = 0;
      
      // 处理不同格式的时间字符串
      if (timeString.includes(':')) {
        const timePart = timeString.includes(' ') ? timeString.split(' ')[1] : timeString;
        const parts = timePart.split(':');
        hour = parseInt(parts[0]) || 0;
        minute = parseInt(parts[1]) || 0;
      }
      
      // 将时间转换为角度（24小时制，0点在顶部，顺时针）
      // 0点 = 0度，6点 = 90度，12点 = 180度，18点 = 270度
      const totalMinutes = hour * 60 + minute;
      const angle = (totalMinutes / (24 * 60)) * 360;
      
      // 调整角度，使0点在顶部（-90度偏移）
      return (angle - 90 + 360) % 360;
    },
    /**
     * 解析时长字符串为分钟数
     * @param {string|number} durationStr - 时长字符串，如 "9小时7分" 或 "2小时17分"，也可能是数字（分钟数）
     * @returns {number} 分钟数
     */
    parseDuration(durationStr) {
      if (durationStr === undefined || durationStr === null || durationStr === '') return 0;
      
      // 如果是数字，直接返回
      if (typeof durationStr === 'number') {
        return durationStr;
      }
      
      // 确保是字符串类型
      const durationString = String(durationStr).trim();
      
      // 如果字符串是纯数字，直接转换为数字返回
      if (/^\d+$/.test(durationString)) {
        return parseInt(durationString, 10);
      }
      
      // 尝试匹配"X小时X分"格式
      const hourMatch = durationString.match(/(\d+)小时/);
      const minuteMatch = durationString.match(/(\d+)分/);
      
      const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;
      const minutes = minuteMatch ? parseInt(minuteMatch[1], 10) : 0;
      
      return hours * 60 + minutes;
    },
    timeClick() {
      this.value = !this.value;
      console.log(this.value);
    },
    convertDateToTimestamp(dateString) {
      var parts = dateString.split("/");
      // 新 Date(年, 月 [, 日 [, 时 [, 分 [, 秒 [, 毫秒]]]]]) 中的月份是从0开始的，所以需要减1
      var date = new Date(parts[0], parts[1] - 1, parts[2]);
      return date.getTime();
    },
    timestampToDateFormat(timestamp) {
      const dateObj = new Date(timestamp); // 创建Date对象
      const year = dateObj.getFullYear(); // 获取年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取月份，并补零
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取日期，并补零

      return `${month}月${day}日`; // 返回转换后的日期格式
    },
    timestampToDateFormat1(timestamp) {
      const dateObj = new Date(timestamp); // 创建Date对象
      const year = dateObj.getFullYear(); // 获取年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取月份，并补零
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取日期，并补零

      return `${year}/${month}/${day}`; // 返回转换后的日期格式
    },
    timestampToDateFormat2(timestamp) {
      const dateObj = new Date(timestamp); // 创建Date对象
      const year = dateObj.getFullYear(); // 获取年份
      const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取月份，并补零
      const day = ("0" + dateObj.getDate()).slice(-2); // 获取日期，并补零

      return `${year}年${month}月${day}日`; // 返回转换后的日期格式
    },
    timeLeft() {
      this.week = this.getWeek(
        this.timestampToDateFormat1(
          this.convertDateToTimestamp(this.transferTime(this.time)) - 86400000
        )
      );
      this.leftTime =
        this.convertDateToTimestamp(this.transferTime(this.time)) - 86400000;
      this.time = this.timestampToDateFormat2(this.leftTime);
      this.newtime = this.timestampToDateFormat(this.leftTime);
      this.getData()
      console.log(this.timestampToDateFormat(this.leftTime));
      //console.log(this.leftTime)
      // console.log(this.week)
    },
    getTransferTime(data) {
      let str = data.replace(/\//g, '-');
      return str;
    },
    timeRight() {
      this.week = this.getWeek(
        this.timestampToDateFormat1(
        this.convertDateToTimestamp(this.transferTime(this.time)) + 86400000
        )
      );
      this.leftTime =
        this.convertDateToTimestamp(this.transferTime(this.time)) + 86400000;
      this.time = this.timestampToDateFormat2(this.leftTime);
      this.newtime = this.timestampToDateFormat(this.leftTime);
      console.log(this.timestampToDateFormat(this.leftTime));
      this.getData()
    },
    parentMethod(msg) {
      console.log(msg);
      this.time = msg;
      this.week = this.getWeek(this.transferTime(this.time));
      let originalString = msg;
      this.newtime = originalString.slice(5);
      this.name = this.data[0];
      this.getData();
    },
    closeMethod(msg) {
      this.bulletFrameIf = msg;
    },
    transferTime(data) {
      let str = data;
      let regex = /年/g; // 使用正则表达式并设置全局标志g
      let regex1 = /月/g; // 使用正则表达式并设置全局标志g
      var newStr = str.replace(regex, "/"); // 替换所有的"World"为"Earth"
      var newStr2 = newStr.replace(regex1, "/"); // 替换所有的"World"为"Earth"
      return newStr2.slice(0, -1);
    },
    getWeek(dateStr) {
      var date = ""; //周几
      let weeks = {
        1: "星期一",
        2: "星期二",
        3: "星期三",
        4: "星期四",
        5: "星期五",
        6: "星期六",
        0: "星期日",
      };
      date = new Date(dateStr);
      let weekIndex = date.getDay();
      date = weeks[weekIndex];
      return date;
    },
  },
};
</script>
<style lang="less" scoped>
.sleep-page {
  position: relative;
  min-height: 100vh;
  background: #F2F3F5;
  padding-bottom: 20px;
  
  /* 确保背景色覆盖整个页面，包括滚动区域 */
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #F2F3F5;
    z-index: -1;
    pointer-events: none;
  }
  
  /* 顶部导航栏 - 参考 skinTemperature 页面 */
  .sleep-header {
    position: relative;
    width: 100%;
    min-height: 220px;
    overflow: hidden;
    margin-bottom: 0;
  }

  .header-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .header-bg-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  .header-nav {
    position: relative;
    z-index: 100;
  display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    min-height: 44px;
  }

  .nav-back-btn {
    position: fixed;
    left: 16px;
    z-index: 1000;
    width: 28px;
    height: 28px;
  padding: 0;
    background: #ffffff;
    border: none;
    border-radius: 50%;
    color: #000000;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .nav-back-btn i {
    font-size: 16px;
    font-weight: 600;
    color: #000000;
  }

  .nav-back-btn:hover {
    background: #f5f5f5;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .nav-back-btn:active {
    transform: translateY(0) scale(0.95);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .nav-title {
    flex: 1;
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .nav-placeholder {
    flex-shrink: 0;
    width: 28px;
  }

  /* 内容区域 */
  .sleep-content {
    width: 100%;
    padding: 16px;
  position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: transparent;
  }

  /* 睡眠时长数据卡片 - 参考 bloodOxygen 页面 */
  .sleep-header-card {
    padding: 16px;
    margin: 0 0 16px 0;
    background-image: url('~@/assets/sleep/Rectangle_852@2x.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    overflow: hidden;
  }

  .sleep-header-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
    min-width: 0;
  }

  .sleep-header-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
    align-items: flex-start;
  }

  .sleep-title-section {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    
    .sleep-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-right: 8px;
      background-image: url('~@/assets/sleep/Frame_3003@2x (2).png');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      flex-shrink: 0;
    }
    
    .sleep-title-text {
      font-size: 16px;
      font-weight: 500;
      color: #000000;
    }
  }

  .sleep-value-section {
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;
    
    .sleep-value {
      font-size: 28px;
      font-weight: bold;
      color: #000000;
      line-height: 1;
    }
  }

  .sleep-time-range {
    font-size: 14px;
    color: #999999;
    line-height: 1;
  }

  .sleep-header-right {
    flex-shrink: 0;
    display: flex;
    align-items: flex-start;
    max-width: 50%;
    min-width: 0;
  }

  .sleep-date {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #000000;
    cursor: pointer;
    white-space: nowrap;
    max-width: 100%;
    text-overflow: ellipsis;
    position: relative;
    left: -10px;
    
    i {
      margin-left: 4px;
      font-size: 14px;
      color: #666666;
      flex-shrink: 0;
    }
  }

  /* 圆形图表容器 */
  .sleep-chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin: 16px 0;
    min-height: 170px;
    
    .sleep-chart-wrapper {
      flex-shrink: 0;
      position: relative;
      width: 170px;
      height: 170px;
      
      .sleep-chart {
        width: 100%;
        height: 100%;
      }
      
      .sleep-chart-score {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 10;
        pointer-events: none;
        
        .sleep-chart-score-value {
          font-size: 28px;
          font-weight: bold;
          color: #000000;
          line-height: 1.2;
          margin-bottom: 4px;
        }
        
        .sleep-chart-score-label {
          font-size: 12px;
          color: #666666;
          line-height: 1;
        }
      }
    }
  }

  /* 睡眠阶段图例 */
  .sleep-stage-legend {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 12px;
    margin-top: 16px;
    padding: 0;
  }

  /* 睡眠心率卡片 */
  .sleep-heart-rate-card {
    margin: 16px 0;
    padding: 16px;
    background-image: url('~@/assets/sleep/Rectangle_853@2x (5).png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    overflow: hidden;
  }

  .shr-header {
    margin-bottom: 16px;
  }

  .shr-title-section {
    display: flex;
    align-items: center;
  }

  .shr-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    background-image: url('~@/assets/sleep/Frame_4359@2x.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    flex-shrink: 0;
  }

  .shr-title-text {
    font-size: 16px;
    font-weight: 500;
    color: #000000;
  }

  .shr-chart-wrapper {
    margin: 16px 0;
    padding: 0;
    
    /* 隐藏 echarts 组件内部显示的心率值文本，因为我们已经在底部统计中显示了 */
    > div > div:first-child {
      display: none;
    }
  }

  .shr-stats {
    margin-top: 16px;
    background: #FFFFFF;
    border-radius: 10px;
    overflow: hidden;
  }

  .shr-stat-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    padding: 0 16px;
    font-size: 14px;
    color: #000000;
    border-bottom: 1px solid #e5e5e5;

    &:last-child {
      border-bottom: none;
    }

    .shr-stat-label {
      display: flex;
      align-items: center;
      position: relative;
      font-weight: 400;
      color: #000000;
    }

    .shr-question {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 16px;
      height: 16px;
      margin-left: 4px;
      background: #F5F5F5;
      border-radius: 50%;
      font-size: 12px;
      color: #999999;
      cursor: pointer;
      flex-shrink: 0;
    }

    .shr-stat-value {
      font-weight: 400;
      color: #000000;
    }
  }

  .sleep-stage-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 16px 8px;
    background: #FFFFFF;
    border-radius: 12px;
    
    .stage-label-row {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 6px;
      gap: 6px;
    }
    
    .stage-icon {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      flex-shrink: 0;
      
      &.deep-sleep-icon {
        background: #4B37FF;
      }
      
      &.light-sleep-icon {
        background: #7B76FF;
      }
      
      &.rem-sleep-icon {
        background: #43D867;
      }
    }
    
    .stage-label {
      font-size: 11px;
      color: #666666;
      text-align: center;
      line-height: 1.4;
    }
    
    .stage-value {
      display: flex;
      align-items: baseline;
      justify-content: center;
      text-align: center;
      
      .stage-value-number {
        font-size: 16px;
        font-weight: bold;
        color: #000000;
        line-height: 1;
      }
      
      .stage-value-unit {
        font-size: 12px;
        font-weight: normal;
        color: #666666;
        margin-left: 2px;
        line-height: 1;
      }
    }
  }
}

* {
  // margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";
}
#myCanvas1 #myId {
  height: 7.5rem !important;
}
.time {
  font-size: 15px;
  color: #636363;
  text-align: center;
}

.down-arrow:after {
  content: "";
  display: block;
  width: 0px;
  height: 0px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #666666;
  margin-top: 10px;
}
.totalBox {
  width: 93%;
  height: 95px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 16px;
  padding: 24px 10px;
}
.numberTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 22px;
  color: #333333;
  line-height: 33px;
  text-align: center;
  font-style: normal;
}
.nameTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 13px;
  color: #999999;
  line-height: 20px;
  text-align: center;
  font-style: normal;
}
.defeat {
  width: 100%;
  height: 40px;
  background: #f3f3f3;
  border-radius: 10px;
  margin-top: 16px;
  display: flex;
  /* justify-content: center;  */
  align-items: left;
}
.drop {
  width: 8px;
  height: 8px;
  background: #209f66;
  border-radius: 100%;
  margin: 0px 10px;
}
.defeatName {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: normal;
  font-size: 16px;
  color: #333333;
  text-align: left;
  font-style: normal;
  display: flex;
  justify-content: center;
  align-items: center; /* 垂直居中 */
  margin-left: 10px;
}
.paceTiele {
  width: 93%;
  height: 88px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 10px;
  margin-top: 16px;
  /* padding: 12px 0px; */
}
.reachTheStandardTitle {
  font-family: HiraginoSansGB, HiraginoSansGB;
  font-weight: 800;
  font-size: 16px;
  color: #333333;
  line-height: 24px;
  text-align: left;
  font-style: normal;
  padding-left: 16px;
  position: relative;
}
.total {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 44px;
  line-height: 44px;
  padding-left: 16px;
  border-bottom: 1px solid #e5e5e5;
  margin-top: 5px;
}
.thisWeek {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 44px;
  line-height: 44px;
  padding-left: 16px;
  /* margin-top: 8px; */
  display: flex;
  justify-content: center;
  align-items: center;
}
.lastweek {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 43px;
  line-height: 43px;
  padding-left: 16px;
  margin-top: 8px;
}
.continuous {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #000000;
  text-align: left;
  font-style: normal;
  height: 43px;
  line-height: 43px;
  padding-left: 16px;
  /* margin-top: 5px; */
}
.day {
  float: right;
  margin-right: 8px;
  font-size: 14px;
  color: #151515;
}
/* 睡眠统计卡片 - 优化样式 */
.sleep-stats-card {
  margin: 0 0 12px 0;
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  
  .ssc-title {
    display: flex;
    align-items: center;
    padding: 12px 16px 8px 16px;
    font-weight: bold;
    font-size: 14px;
    color: #333333;
    line-height: 1.2;
    position: relative;
    
    span {
      flex: 1;
      display: inline-flex;
      align-items: center;
      
      .ssc-question {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 16px;
        height: 16px;
        margin-left: 4px;
        background: #F5F5F5;
        border-radius: 50%;
        font-size: 11px;
        color: #999999;
        cursor: pointer;
        flex-shrink: 0;
      }
    }
  }
  
  .ssc-content {
    padding: 0 16px 12px 16px;
  }
  
  .ssc-value-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }
  
  .ssc-main-value {
    font-size: 18px;
    font-weight: bold;
    color: #000000;
    flex: 1;
  }
  
  .ssc-progress-wrapper {
    margin: 8px 0;
  }
  
  .ssc-progress-bar {
    position: relative;
    width: 100%;
    height: 10px;
    background-color: #e5e5e5;
    border-radius: 5px;
    overflow: visible;
    margin-top: 30px;
  }
  
  .ssc-progress-fill {
    height: 10px;
    background: linear-gradient(231deg, #00c275 0%, #00b5ba 100%);
    border-radius: 5px;
  }
  
  .ssc-progress-dot {
    position: absolute;
    width: 15px;
    height: 15px;
    background: #ffffff;
    border: 2px solid #00c275;
    border-radius: 50%;
    top: -2.5px;
    transform: translateX(-50%);
  }
  
  .ssc-progress-label {
    position: absolute;
    top: -24px;
    left: 180%;
    transform: translateX(-50%);
    font-size: 12px;
    color: #209f66;
    white-space: nowrap;
  }
  
  .ssc-status-tag {
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
  }
  
  .ssc-state {
    width: 56px;
    height: 28px;
    border-radius: 4px;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    
    &.ssc-state-normal {
      background: rgba(32, 159, 102, 0.1);
      color: #209f66;
    }
    
    &.ssc-state-low {
      background: rgba(253, 221, 70, 0.1);
      color: #ffd200;
    }
    
    &.ssc-state-high {
      background: rgba(255, 0, 0, 0.1);
      color: #ff0000;
    }
  }
  
  .ssc-reference {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #999999;
    margin-top: 4px;
  }
}

.weeklySteps {
  margin-top: 16px;
  width: 93%;
  height: 113px;
  background: #ffffff;
  border-radius: 10px;
  padding: 12px 5px;
}
.progressDiv {
  width: 92%;
  margin-top: 1.5px;
  position: relative;
}
.progress-bar {
  width: 100%;
  background-color: #e5e5e5;
  border-radius: 50px;
  overflow: hidden;
}

.progress {
  height: 5px;
  background: linear-gradient(231deg, #00c275 0%, #00b5ba 100%);
  border-radius: 50px;
  /* transition: width 1s ease; */
  margin-left: 0 !important;
}
.last {
  height: 5px;
  background: linear-gradient(231deg, #ffa94a 0%, #ff8e32 100%) !important;
  border-radius: 50px;
  margin-left: 0 !important;
}
.lastDay {
  width: 8px;
  height: 8px;
  background: #ffffff;
  border: 2px solid #ff9315 !important;
  border-radius: 100%;
  position: absolute;
  top: -1.5px;
}
.progressDay {
  width: 8px;
  height: 8px;
  background: #ffffff;
  border: 2px solid #00c275;
  /* transition: width 1s ease; */
  border-radius: 100%;
  position: absolute;
  top: -1.5px;
}
.legend {
  font-size: 13px;
  background-color: #f3f4f6 !important;
  padding: 20px 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.deepSleep {
  width: 8px;
  height: 8px;
  background: #008c00;
  border-radius: 100%;
  display: inline-block;
}
.question {
  width: 16px;
  height: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 16px;
  border-radius: 50%;
  background: #dcdcdc;
  position: absolute;
  right: -22px;
  top: 2px;
  font-size: 13px;
}
.question1 {
  left: -105px;
  top: 3px;
  right: none;
}
.state {
  width: 56px;
  height: 28px;
  background: rgba(32, 159, 102, 0.1);
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #209f66;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  float: right;
  margin-right: 8px;
}
.state1 {
  width: 56px;
  height: 28px;
  background: rgba(253, 221, 70, 0.1);
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffd200;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  float: right;
  margin-right: 8px;
}
.state2 {
  width: 56px;
  height: 28px;
  background-color: rgba(255, 0, 0, 0.1);
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: red;
  line-height: 28px;
  text-align: center;
  font-style: normal;
  float: right;
  margin-right: 8px;
}
.referto {
  color: #999999;
  font-size: 13px;
  margin: 0;
  padding-left: 16px;
}
.referto2 {
  float: right;
  margin-right: 8px;
}
.jdt {
  width: 128px;
}
.jdtzb {
  position: absolute;
  width: 100px;
  left: -22px;
  top: -34px;
  font-weight: 400;
  font-size: 12px;
  color: #209f66;
  font-style: normal;
}
.echartsBar {
  width: 144px;
  height: 144px;
  border: 17px solid #f8f8f8;
  /* opacity: 0.68; */
  border-radius: 100%;
  position: relative;
  margin-left:24px;
  margin-top:40px
}
.Y {
  width: 130px;
  height: 130px;
  border: 1px solid #00c275;
  opacity: 0.22;
  border-radius: 100%;
  position: absolute;
  top: -9px;
  left: -8px;
}
.chart {
    top: -24px;
    width: 160px;
    height: 160px;
    left: -23px;
}
.smdf {
  color:#4A4A4A;
  font-size: 12px;
  text-align: center;
}
.df {
  font-family: HiraginoSansGB, HiraginoSansGB;
font-weight: normal;
font-size: 16px;
color: #333333;
font-style: normal;
text-align: center;
}
.smDiv {
  position: absolute;
    top: 39px;
    left: 33px;
}
.smtit {
  width: 73px;
height: 31px;
background: #00C275;
border-radius: 6px;
font-weight: normal;
font-size: 13px;
color: #FFFFFF;
line-height: 31px;
text-align: center;
font-style: normal;
margin-left: 0px;
}
.smtime {
  font-family: HiraginoSansGB, HiraginoSansGB;
font-weight: normal;
font-size: 16px;
color: #333333;
margin:8px 0px;
font-style: normal;
}
.border {
  border-top: 1px dashed #C0C0C0;
  width: 130%;
}
.right {
  margin-top:10px
}
.lenlist {
  margin: 10px 0px;
  color: #151515;
  font-size: 13px;
}
.sellpTime {
  font-size: 14px;
  position: absolute;
  top: 23px;
  left: 58px;
}
</style>


// WEBPACK FOOTER //
// src/views/sleep/index.vue